import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "swag-token";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const COLOR_HEX = {
  Black: "#111827",
  "Heather Grey": "#9CA3AF",
  "Google Blue": "#1A73E8",
  "Olive Green": "#556B2F",
  White: "#FFFFFF",
};

export const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-");
